import type { IndustryPack } from '../types'

export const CONSUMER_V1: IndustryPack = {
  pack_id: 'consumer_v1',
  industry: 'consumer',
  pack_name: 'Consumer Brands',
  version: 1,
  rules: [
    {
      rule_id: 'CON_001_unverifiable_superlative',
      severity: 'warn',
      match: { type: 'keyword_list', keywords: ['the best', '#1', 'number one', 'the only', 'no other', 'unparalleled', 'unmatched', 'unrivaled'] },
      message: 'Unverifiable superlative. FTC Act §5 requires substantiation for superiority claims.',
      cited_authority: 'FTC Guides Concerning Use of Endorsements and Testimonials (16 C.F.R. § 255)',
    },
    {
      rule_id: 'CON_002_natural_claim',
      severity: 'warn',
      match: { type: 'keyword_list', keywords: ['all natural', '100% natural', 'all-natural', 'pure natural'] },
      message: '"Natural" claim requires FDA/FTC substantiation. No formal legal definition exists — high complaint risk.',
      cited_authority: 'FTC Act §5; FDA CPG Sec. 100.100',
    },
    {
      rule_id: 'CON_003_green_claim',
      severity: 'warn',
      match: { type: 'keyword_list', keywords: ['eco-friendly', 'carbon neutral', 'zero carbon', 'sustainable', 'green product', 'environmentally friendly'] },
      message: 'Environmental claim. FTC Green Guides require specific, substantiated environmental benefit claims.',
      cited_authority: 'FTC Green Guides (16 C.F.R. Part 260)',
      suggested_rewrite_template: 'Replace with specific claim: "Made with 30% recycled materials" rather than "eco-friendly".',
    },
    {
      rule_id: 'CON_004_health_claim',
      severity: 'block',
      match: { type: 'keyword_list', keywords: ['prevents', 'cures', 'treats', 'reduces risk of disease', 'clinically proven to'] },
      message: 'Drug/disease claim on non-prescription product. FDA considers this an unauthorized drug claim.',
      cited_authority: 'FDA Food, Drug, and Cosmetic Act § 403(r); 21 C.F.R. § 101.14',
    },
    {
      rule_id: 'CON_005_accessibility_alt',
      severity: 'info',
      match: { type: 'keyword_list', keywords: ['see image', 'click image', 'view graphic', 'as shown above'] },
      message: 'Image-only communication reference. Ensure alt text or equivalent text description is provided (WCAG 2.1 Level AA).',
      cited_authority: 'WCAG 2.1 Success Criterion 1.1.1 (Non-text Content)',
    },
    {
      rule_id: 'CON_006_price_claim',
      severity: 'warn',
      match: { type: 'regex', pattern: 'save\\s+\\d+%|\\d+%\\s+off|compare\\s+at|was\\s+\\$', flags: 'i' },
      message: 'Price comparison claim. FTC requires that reference prices (was/compare-at) reflect bona fide original prices.',
      cited_authority: 'FTC Guides Against Deceptive Pricing (16 C.F.R. Part 233)',
    },
    {
      rule_id: 'CON_007_testimonial_disclaimer',
      severity: 'warn',
      match: { type: 'keyword_list', keywords: ['customer says', 'review:', 'testimonial', '"I lost', '"It worked'] },
      message: 'Testimonial present. FTC requires: (a) disclosure of material connections, (b) typical results disclaimer.',
      cited_authority: 'FTC Endorsement Guides (16 C.F.R. § 255); FTC Act §5',
    },
    {
      rule_id: 'CON_008_cultural_sensitivity',
      severity: 'info',
      match: { type: 'keyword_list', keywords: ['exotic', 'tribe', 'primitive', 'Oriental', 'third world'] },
      message: 'Culturally dated or potentially offensive language detected. Review for cultural sensitivity.',
    },
  ],
}
